import initializeWishListView from './initializeWishListView';
import HeaderToolbarItemView from './views/HeaderToolbarItemView';
import WishListItemView from './views/WishListItemView';
import WishListOpenView from './views/WishListOpenView';
import FooterItemView from './views/FooterItemView';

const App = Backbone.Marionette.Application.extend({
	regions: {
		wishlistWrapper: '#wishlistWrapper',
		wishlistHeader: '#wishlistHeader',
		wishlistOptions: '#wishlistOptions',
		wishlistBody: '#wishlistBody',
		wishlistFooter: '#wishlistFooter'
	},
	initialize () {

		const headerView = new HeaderToolbarItemView({ el: '#wishlistHeader' });
		this.getRegion('wishlistWrapper').attachView(headerView);

		const optionView = new WishListOpenView({ el: '#wishlistOptions' });
		this.getRegion('wishlistOptions').attachView(optionView);

		const wishlistItemView = new WishListItemView({ el: '#wishlistBody' });
		this.getRegion('wishlistBody').attachView(wishlistItemView);
		initializeWishListView(true);

		const footerView = new FooterItemView({ el: '#wishlistFooter' });
		this.getRegion('wishlistFooter').attachView(footerView);

	}
});

const app = new App();

export default app;
